export const GET_LIST_CHAINS = "GET_LIST_CHAINS"
export const GET_LIST_CHAINS_ERR = "GET_LIST_CHAINS_ERR"

export const ADD_CHAIN_START = "ADD_CHAIN_START"
export const ADD_CHAIN_FINISH = "ADD_CHAIN_FINISH"
export const ADD_CHAIN = "ADD_CHAIN"
export const ADD_CHAIN_ERR = "ADD_CHAIN_ERR"

export const RESET_LIST_CHAIN = "RESET_LIST_CHAIN"